var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
exports.Container = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-flex;\n    align-items: center;\n    white-space: nowrap;\n    user-select: none;\n    cursor: pointer;\n    border: 1px solid transparent;\n    border-radius: 2px;\n    font-weight: 500;\n    transition: background 200ms;\n    justify-content: ", ";\n    font-size: ", ";\n    padding: ", ";\n    color: ", ";\n    background: ", ";\n    &:focus {\n        outline: 0;\n    }\n"], ["\n    display: inline-flex;\n    align-items: center;\n    white-space: nowrap;\n    user-select: none;\n    cursor: pointer;\n    border: 1px solid transparent;\n    border-radius: 2px;\n    font-weight: 500;\n    transition: background 200ms;\n    justify-content: ", ";\n    font-size: ",
    ";\n    padding: ",
    ";\n    color: ",
    ";\n    background: ",
    ";\n    &:focus {\n        outline: 0;\n    }\n"])), function (props) { return (props.hasIcon && props.hasContent ? 'space-between' : 'center'); }, function (props) {
    if (props.size === 'large')
        return '16px';
    return '13px';
}, function (props) {
    if (props.size === 'large')
        return '3px 12px';
    return '2px 11px';
}, function (props) {
    if (props.variant === 'primary') {
        return props.theme.colors.overAccent;
    }
    if (props.variant === 'success') {
        return props.theme.colors.overSuccess;
    }
    if (props.variant === 'warning') {
        return props.theme.colors.overWarning;
    }
    if (props.variant === 'danger') {
        return props.theme.colors.overDanger;
    }
    return props.theme.colors.text;
}, function (props) {
    if (props.variant === 'primary') {
        return props.theme.colors.accent;
    }
    if (props.variant === 'success') {
        return props.theme.colors.success;
    }
    if (props.variant === 'warning') {
        return props.theme.colors.warning;
    }
    if (props.variant === 'danger') {
        return props.theme.colors.danger;
    }
    return props.theme.colors.background;
});
var templateObject_1;
